import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { HiSquares2X2, HiInbox, HiMap } from 'react-icons/hi2'
import { TabBar, Loader } from '../ui'
import { useCriticalTickets } from '../hooks/useCriticalTickets'

// 900px — ilova qobig'ining chegarasi (DESIGN.md 8): shu yerdan pastda yon
// panel oqimdan chiqadi va pastki qator kerak bo'ladi.
//
// Nima uchun CSS bilan yashirilmaydi, balki umuman CHIZILMAYDI: bu qator
// kritiklar sonini so'rab turadi. `display: none` qilingan komponent ham
// so'rov yuboraveradi — ya'ni kompyuterda hech kim ko'rmaydigan qator uchun
// har 10 soniyada bekorga backend bezovta bo'lardi.
const MOBILE = '(max-width: 900px)'

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE).matches)

  useEffect(() => {
    const mq = window.matchMedia(MOBILE)
    const onChange = (e) => setIsMobile(e.matches)
    mq.addEventListener('change', onChange)
    setIsMobile(mq.matches)   // obuna orasida oyna o'zgargan bo'lishi mumkin
    return () => mq.removeEventListener('change', onChange)
  }, [])

  return isMobile
}

// Telefondagi pastki qator — kunlik ish yuzalari.
//
// Nima uchun ATIGI uchtasi: qatorda yorliqlar to'liq o'qilishi kerak, qisqartma
// ("Murojaat" o'rniga "Muroj…") operatorni sekinlashtiradi. Uchta yuzada eng
// tor telefonda ham har bir yorliq butun sig'adi va tegish maydoni katta
// qoladi. Qolgan sahifalar yo'qolmaydi — ular yuqoridagi menyudan ochiladi
// (DESIGN.md 8: telefonda ma'lumot YASHIRILMAYDI, joylashuv o'zgaradi).
//
// Yorliqlar yon paneldagi nomlarning AYNAN o'zi: bitta sahifa ikki joyda ikki
// xil atalsa, operator ular boshqa-boshqa joy deb o'ylaydi.
const TABS = [
  { id: 'dashboard', label: 'Bosh sahifa', icon: HiSquares2X2, path: '/' },
  { id: 'tickets',   label: 'Murojaatlar', icon: HiInbox,      path: '/tickets' },
  { id: 'map',       label: 'Xarita',      icon: HiMap,        path: '/map' },
]

export default function MobileTabBar() {
  // Ichkarisi alohida komponent: `useCriticalTickets` faqat qator haqiqatan
  // chizilganda ishga tushsin (hook'ni shartli chaqirib bo'lmaydi).
  return useIsMobile() ? <MobileTabBarLive /> : null
}

function MobileTabBarLive() {
  const navigate     = useNavigate()
  const { pathname } = useLocation()
  const { pending } = useCriticalTickets()

  // Ochilgan murojaat (`/ticket/12`) ham "Murojaatlar" yuzasi hisoblanadi —
  // aks holda tafsilotga kirgan zahoti tomchi qatordan yo'qolib qolardi.
  const active =
    pathname === '/' ? 'dashboard'
    : pathname.startsWith('/ticket') ? 'tickets'
    : pathname.startsWith('/map') ? 'map'
    : null

  const items = TABS.map((t) => (
    t.id === 'tickets'
      ? { ...t, count: pending, tone: 'critical' }
      : t
  ))

  return (
    <MobileTabBarView
      items={items}
      active={active}
      pending={pending}
      onTab={(id) => navigate(TABS.find((t) => t.id === id).path)}
      onCritical={() => navigate('/kritik')}
    />
  )
}

// Ko'rinish alohida: katalog sahifasi (/ui) uni marshrutsiz ham chizadi.
export function MobileTabBarView({ items, active, pending, onTab, onCritical }) {
  return (
    <TabBar
      className="app-tabbar"
      items={items}
      value={active}
      onChange={onTab}
      aside={{
        label: 'Kritik murojaatlar',
        onClick: onCritical,
        count: pending,
        tone: 'critical',
        // Doira kritik yo'q bo'lsa ham turadi: tugma o'rnini o'zgartirmasligi
        // kerak, aks holda operator uni bosmoqchi bo'lganda joyi bo'sh chiqardi.
        //
        // `label={false}` — yonida matn chiqmaydi (doirada joy yo'q),
        // `aria-hidden` — belgining o'z `role="status"` i tugma ichida ortiqcha:
        // ma'noni tugmaning `aria-label` i tashiydi ("Kritik murojaatlar: 3 ta"),
        // ikkalasi qolsa ekran o'quvchi bitta tugmani ikki marta o'qirdi.
        content: <Loader state="composing" size="lg" label={false} aria-hidden="true" />,
      }}
    />
  )
}
